import React from 'react'
import { ApolloClient, ApolloProvider, HttpLink } from '@apollo/client'
import { InMemoryCache } from '@apollo/client/cache'

import { resolvers, typeDefs } from '~/app/state/schema'
import { API_GATEWAY } from '~/app/constants'

/**
 *
 */

// @ts-expect-error TS(7006) FIXME: Parameter 'props' implicitly has an 'any' type.
const APIGatewayProvider = (props) => {
  const client = new ApolloClient({
    cache: new InMemoryCache(),
    link: new HttpLink({
      uri: API_GATEWAY,
      credentials: 'include',
      headers: {
        'x-buffer-client-id': 'webapp-engagement',
      },
    }),
    resolvers,
    typeDefs,
    connectToDevTools: process.env.NODE_ENV !== 'production',
  })

  return <ApolloProvider client={client}>{props.children}</ApolloProvider>
}

export default APIGatewayProvider
